import { useParams,useLocation } from "react-router";
import PagesItemComponent from "../../components/Pages/PagesItem";
import { usePagesByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

function PagesItem(){
    const location = useLocation();
    const state= location.state as LocationState | undefined;
    const params = useParams();
    const { data:page, error, isLoading } = usePagesByIdQuery(params.id??"0");
    const {translate}=useTrads();
    return (

        
        error ?<p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        page &&
        <>
          {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_page_update')}</p>}
          <PagesItemComponent page={page}  />
        
        </>

    );
}
export default PagesItem;